import $ from 'jquery';
import adTagBuilder from './jwplayer-ads-homepage';
import Autoplay from './jwplayer-homepage-autoplay';

class JWPlayerInit {
    constructor() {
        this.$playlistWrapper = $('.fc-studios__up-next-list');
        this.$titleWrapper = $('.fc-studios__video-title');
        this.adTag = adTagBuilder.adUrl;
        this.player = {};
        this.options = {
            playlist: '//content.jwplatform.com/feeds/DCmFDcAw.json',
            advertising: {
                client: 'googima',
                tag: this.adTag
            },
            ga: {}, // for prod
            skin: {
                name: 'fc-custom'
            },
            mute: true //,
            // sharing: {
            //     code: encodeURI('<iframe width="720" height="415" src="//www.fastcompany.com/embed/MEDIAID?rel=1&src=embed&veggiemode=1" frameborder="0" scrolling="no" allowfullscreen></iframe>')
            //     // link: parent ? parent.document.URL : 'http://www.fastcompany.com/embed/MEDIAID'
            // }
        };
    }

    initPlayer() {
        this.player.setup(this.options);

        this.player.on('ready', function () {
            var autoplay = new Autoplay(this.player);
            autoplay.on();
            this.updateTitle();
            this.buildPlaylistSidebar(this.player.getPlaylist());
        }.bind(this));

        this.player.on('play', function () {
            this.updateTitle();
        }.bind(this));
    }

    buildPlaylistSidebar(playlist) {
        for (var i = 1; i < 3; i++) {
            this.$playlistWrapper.append(
                `<li data-index=${i} class="fc-studios__up-next card-hover-effect">
                    <figure data-index=${i} class="fc-studios__up-next__article__figure">
                        <img data-index=${i} src=${playlist[i].image} />
                     </figure>
                    <span data-index=${i} class="fc-studios__up-next-title">${playlist[i].title}</span>
                </li>`
            );
        }

        $('.fc-studios__up-next').click(function (e) {
            var idx = $(e.target).data('index');
            this.player.playlistItem(idx);
            this.updateTitle();
        }.bind(this));
    }

    updateTitle() {
        var video = this.player.getPlaylistItem();
        this.$titleWrapper.text(video.title);
    }

    on() {
        $.getScript('//content.jwplatform.com/libraries/76APbejE.js', function () {
            this.player = jwplayer('homepage-jwplayer');
            this.initPlayer();
        }.bind(this));
    }

    off() {
        this.player = {};
    }
}

export default new JWPlayerInit();
